import { VueModule } from '@Foundation/utilities';
import ExpandableKeyFigureCard from './code/Scripts/components/expandable-key-figure-card.vue';

export default VueModule({
  components: {
    ExpandableKeyFigureCard
  }
});
